/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { FormulaireCitoyenDto } from '../models/formulaire-citoyen-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des formulaires citoyens
 */
@Injectable({
  providedIn: 'root',
})
export class FormulairesCitoyensService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation formulaireCitoyenGetList
   */
  static readonly FormulaireCitoyenGetListPath = '/api/formulaires-citoyens/list';

  /**
   * Renvoie la liste des formulaires citoyens.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireCitoyenGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireCitoyenGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<FormulaireCitoyenDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesCitoyensService.FormulaireCitoyenGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FormulaireCitoyenDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des formulaires citoyens.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireCitoyenGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireCitoyenGetList(params?: {
  }): Observable<Array<FormulaireCitoyenDto>> {

    return this.formulaireCitoyenGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FormulaireCitoyenDto>>) => r.body as Array<FormulaireCitoyenDto>)
    );
  }

  /**
   * Path part for operation formulaireCitoyenLoadList
   */
  static readonly FormulaireCitoyenLoadListPath = '/api/formulaires-citoyens/load-list';

  /**
   * Renvoie la liste des formulaires citoyens (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireCitoyenLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formulaireCitoyenLoadList$Response(params: {

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesCitoyensService.FormulaireCitoyenLoadListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des formulaires citoyens (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireCitoyenLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formulaireCitoyenLoadList(params: {

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.formulaireCitoyenLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation formulaireCitoyenGet
   */
  static readonly FormulaireCitoyenGetPath = '/api/formulaires-citoyens/{id}';

  /**
   * Renvoie le formulaire citoyen spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formulaireCitoyenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireCitoyenGet$Response(params: {

    /**
     * Identifiant du formulaire citoyen
     */
    id: number;
  }): Observable<StrictHttpResponse<FormulaireCitoyenDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormulairesCitoyensService.FormulaireCitoyenGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormulaireCitoyenDto>;
      })
    );
  }

  /**
   * Renvoie le formulaire citoyen spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formulaireCitoyenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formulaireCitoyenGet(params: {

    /**
     * Identifiant du formulaire citoyen
     */
    id: number;
  }): Observable<FormulaireCitoyenDto> {

    return this.formulaireCitoyenGet$Response(params).pipe(
      map((r: StrictHttpResponse<FormulaireCitoyenDto>) => r.body as FormulaireCitoyenDto)
    );
  }

}
